import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ConfirmProvider } from "@/context/ConfirmContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Colecciones from "@/pages/Colecciones";
import ColeccionDetalle from "@/pages/ColeccionDetalle";
import ModeloDetalle from "@/pages/ModeloDetalle";
import Kanban from "@/pages/Kanban";
import Usuarios from "@/pages/Usuarios";
import Listas from "@/pages/Listas";
import Notificaciones from "@/pages/Notificaciones";
import Plantillas from "@/pages/Plantillas";
import Roles from "@/pages/Roles";
import RoleEditor from "@/pages/RoleEditor";
import Instructivos from "@/pages/Instructivos";
import Solicitudes from "@/pages/Solicitudes";
import SolicitudMuestraDetalle from "@/pages/SolicitudMuestraDetalle";
import SolicitudesMuestraEliminadas from "@/pages/SolicitudesMuestraEliminadas";
import Muestras from "@/pages/Muestras";
import MuestraDetalle from "@/pages/MuestraDetalle";
import MuestrasTablero from "@/pages/MuestrasTablero";
import Calendario from "@/pages/Calendario";
import Hormas from "@/pages/Hormas";
import HormaDetalle from "@/pages/HormaDetalle";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null)
    return (
      <div className="min-h-screen flex items-center justify-center text-slate-400" data-testid="loading-screen">
        Cargando…
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <ConfirmProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Protected><Dashboard /></Protected>} />
            <Route path="/colecciones" element={<Protected><Colecciones /></Protected>} />
            <Route path="/colecciones/:id" element={<Protected><ColeccionDetalle /></Protected>} />
            <Route path="/modelos/:id" element={<Protected><ModeloDetalle /></Protected>} />
            <Route path="/hormas" element={<Protected><Hormas /></Protected>} />
            <Route path="/hormas/:id" element={<Protected><HormaDetalle /></Protected>} />
            <Route path="/kanban" element={<Protected><Kanban /></Protected>} />
            <Route path="/solicitudes" element={<Protected><Solicitudes /></Protected>} />
            <Route path="/solicitudes/muestra/:id" element={<Protected><SolicitudMuestraDetalle /></Protected>} />
            <Route path="/solicitudes/eliminadas" element={<Protected><SolicitudesMuestraEliminadas /></Protected>} />
            <Route path="/muestras" element={<Protected><Muestras /></Protected>} />
            <Route path="/muestras/tablero" element={<Protected><MuestrasTablero /></Protected>} />
            <Route path="/muestras/:id" element={<Protected><MuestraDetalle /></Protected>} />
            <Route path="/usuarios" element={<Protected><Usuarios /></Protected>} />
            <Route path="/listas" element={<Protected><Listas /></Protected>} />
            <Route path="/notificaciones" element={<Protected><Notificaciones /></Protected>} />
            <Route path="/plantillas" element={<Protected><Plantillas /></Protected>} />
            <Route path="/calendario" element={<Protected><Calendario /></Protected>} />
            <Route path="/roles" element={<Protected><Roles /></Protected>} />
            <Route path="/roles/:roleId" element={<Protected><RoleEditor /></Protected>} />
            <Route path="/instructivos" element={<Protected><Instructivos /></Protected>} />
            <Route path="/instructivos/:id" element={<Protected><Instructivos /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        </ConfirmProvider>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
